import React from "react";
import { Link, Navigate } from "react-router-dom";
import DashboardRevenueMetrics from "../components/DashboardRevenueMetrics";
import { FaTachometerAlt, FaChartLine, FaCar, FaUsers } from "react-icons/fa";
import { useProfile } from "../context/ProfileContext";
import { getAdminLandingPath } from "../utils/adminLanding";

const Dashboard = () => {
  const { profile, assignModule, loading } = useProfile();
  const isSuperAdmin = profile?.role?.slug === "superadmin";

  if (loading) return null;
  if (!isSuperAdmin) {
    return <Navigate to={getAdminLandingPath(profile, assignModule)} replace />;
  }

  return (
    <div className="container mx-auto px-6 py-8 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-8">
        <div className="flex items-center space-x-3">
          <FaTachometerAlt className="text-3xl text-blue-600" />
          <div>
            <h2 className="text-3xl font-bold text-gray-800">Dashboard</h2>
            <p className="text-sm text-gray-600">Revenue Metrics live here; Trips and Drivers metrics are separate pages.</p>
          </div>
        </div>
        <div className="flex items-center space-x-2 text-sm text-gray-600">
          <FaChartLine className="text-green-500" />
          <span>Real-time Analytics</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        <Link
          to="/dashboard/trips-metrics"
          className="flex items-center justify-between bg-white rounded-xl shadow-lg px-6 py-5 border border-gray-200 hover:border-blue-500 transition-all"
        >
          <div>
            <p className="text-sm text-gray-500">View detailed</p>
            <h3 className="text-lg font-semibold text-gray-800">Trips Metrics</h3>
          </div>
          <FaCar className="text-2xl text-blue-600" />
        </Link>
        <Link
          to="/dashboard/drivers-metrics"
          className="flex items-center justify-between bg-white rounded-xl shadow-lg px-6 py-5 border border-gray-200 hover:border-blue-500 transition-all"
        >
          <div>
            <p className="text-sm text-gray-500">View detailed</p>
            <h3 className="text-lg font-semibold text-gray-800">Drivers Metrics</h3>
          </div>
          <FaUsers className="text-2xl text-blue-600" />
        </Link>
      </div>

      <DashboardRevenueMetrics />
    </div>
  );
};

export default Dashboard;